import { isIOS } from 'react-device-detect';

import { PublicPath } from '@/utils/constant';
import image from '@/assets/opengraph/opengraph.jpg';

export default function HTMlHead({
    title = 'Pikabu Special',
    description = 'Development',
    result = false,
    query = '',
}) {
    const host =
        process.env.NODE_ENV === 'production'
            ? 'https://special.pikabu.ru'
            : 'http://localhost:3000';

    return (
        <>
            {isIOS && (
                <meta
                    name="viewport"
                    content="width=device-width, height=device-height, initial-scale=1.0, viewport-fit=cover, maximum-scale=1"
                />
            )}

            <base target="_blank" />

            {/* Favicon */}
            <link
                id="favicon"
                rel="shortcut icon"
                href="https://cs.pikabu.ru/assets/favicon.ico"
                type="image/x-icon"
            />
            <link
                rel="apple-touch-icon"
                href="https://cs.pikabu.ru/assets/images/apple-touch-icon-60x60.png"
            />
            <link
                rel="apple-touch-icon"
                sizes="76x76"
                href="https://cs.pikabu.ru/assets/images/apple-touch-icon-76x76.png"
            />
            <link
                rel="apple-touch-icon"
                sizes="120x120"
                href="https://cs.pikabu.ru/assets/images/apple-touch-icon-120x120.png"
            />
            <link
                rel="apple-touch-icon"
                sizes="152x152"
                href="https://cs.pikabu.ru/assets/images/apple-touch-icon-152x152.png"
            />

            <meta property="og:image" content={host + image.src} />
            <meta name="twitter:image:src" content={host + image.src} />
            <link rel="image_src" href={host + image.src} />
            <meta property="og:url" content={host + PublicPath + query} />

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Pikabu.ru" />
            <meta property="og:title" content={title} />
            <meta property="og:locale" content="ru_RU" />
            <meta property="og:description" content={description} />
            <meta property="og:image:width" content="978" />
            <meta property="og:image:height" content="504" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />

            <meta name="twitter:description" content={description} />
            <meta name="twitter:image:width" content="978" />
            <meta name="twitter:image:height" content="504" />
            <meta name="twitter:domain" content="Pikabu.ru" />
        </>
    );
}
